import { PageInfo as GQLItem } from '../../generated/bo.graphql';
import { take } from '../../util';

export type PageInfo = {
  hasNextPage: boolean;
  hasPreviousPage: boolean;
  startCursor?: string;
  endCursor?: string;
};

export const fromGql = (item: GQLItem): PageInfo =>
  take<PageInfo>(item, 'hasNextPage', 'hasPreviousPage', 'startCursor', 'endCursor');
